export enum FeatureFlag {
    SANDBOX_GLOBAL_LOCK = "sandboxes-global-lock",
    FIN_ALT_SUITE = "fin-alt-suite",
}
